export var EOfferApplicationHistoryItemType;
(function (EOfferApplicationHistoryItemType) {
    EOfferApplicationHistoryItemType["STANDARD_NOTE"] = "STANDARD_NOTE";
    EOfferApplicationHistoryItemType["INTERVIEW"] = "INTERVIEW";
})(EOfferApplicationHistoryItemType || (EOfferApplicationHistoryItemType = {}));
